import type { Metadata } from "next";
import { getAssetImage } from "@/service/image/asset";

interface IMetadata {
  title: string;
  description?: string;
  image?: string;
  noIndex?: boolean;
  canonical?: string;
}

export async function createMetadata({
  title = "Remedium",
  description = "Remedium",
  image = getAssetImage("/og-images/remedium.png"),
  noIndex,
  canonical,
}: IMetadata) {
  // Bez `canonical` nie emitujemy tagu — dawny domyślny "/" kazał Google traktować stronę jak duplikat strony głównej.
  // Przy `noIndex` też go pomijamy: canonical na inny adres + noindex to sprzeczne sygnały dla Google.
  const metadata: Metadata = {
    metadataBase: new URL(process.env.API_URL as string),
    title,
    description,
    ...(canonical && !noIndex
      ? { alternates: { canonical: `https://remedium.md${canonical}` } }
      : {}),
    twitter: {
      title,
      description,
      card: "summary_large_image",
    },
    openGraph: {
      title,
      description,
      url: canonical,
      type: "website",
    },
    ...(noIndex
      ? {
          robots: {
            index: false,
            googleBot: {
              index: false,
            },
          },
        }
      : {}),
  };

  if (image && metadata.openGraph && metadata.twitter) {
    metadata.openGraph.images = [image];
    metadata.twitter.images = [image];
  }

  return metadata;
}

export function createSeoTitleWithSuffix(title: string, delimiter = " - ") {
  const titleWithSuffix = title + delimiter + "Remedium";
  return titleWithSuffix.length > 60 ? title : titleWithSuffix;
}
